// extracted by mini-css-extract-plugin
export default {"app":"layout_app__GpPn4"};